module.exports = __webpack_public_path__ + "img/equipmentS.9d875ed1.jpg";